/**
 * Split.io / Harness feature flag names for Admin UI pages and components.
 * Use only for temporary page/feature gating (e.g. WIP or phased rollout). Permanent
 * authorization should use C2FO User Roles or Features.
 * Use these with usePageFeature() and ComingSoonNavLink to gate "in development" areas.
 * Treatment 'on' = page/component enabled for the user; otherwise show "Coming soon".
 *
 * Define new flags in Split/Harness and add the constant here, then use the same name
 * in the dashboard for targeting by user UUID.
 */
export const PageFlags = {
  /** ESLAP page */
  ESLAP_PAGE: 'admin_eslap_page',
  /** Insights page (e.g. /insights) */
  INSIGHTS_PAGE: 'admin_insights_page',
  /** Divisions section */
  DIVISIONS_PAGE: 'admin_divisions_page',
  /** Markets section (search at /markets, details at /markets/:id) */
  MARKETS_PAGE: 'admin_markets_page',
  /** Market Overview dashboard (table, chart, stats at /market-overview) */
  MARKET_OVERVIEW_PAGE: 'admin_market_overview_page',
  /** Users section */
  USERS_PAGE: 'admin_users_page',
  /** Accounts section (when re-enabled) */
  ACCOUNTS_PAGE: 'admin_accounts_page',
  /** File Delivery section */
  FILE_DELIVERY_PAGE: 'admin_file_delivery_page',
  /** Award administration section */
  AWARD_PAGE: 'admin_award_page',
} as const;

export type PageFlagName = (typeof PageFlags)[keyof typeof PageFlags];
